import { render, staticRenderFns } from "./SharedExploreLabel.vue?vue&type=template&id=68500571&scoped=true&"
import script from "./SharedExploreLabel.vue?vue&type=script&lang=js&"
export * from "./SharedExploreLabel.vue?vue&type=script&lang=js&"
import style0 from "./SharedExploreLabel.vue?vue&type=style&index=0&id=68500571&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68500571",
  null
  
)

export default component.exports